<template>
    <div class="zebra-crossing-detail">
        <!--  表单明细 -->
        <el-form :model="detail">
            <div class="zebra-item">
                <div class="zebra-item_tit">请求登记单</div>
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="所属公司：">{{ detail.company | tableVal(companyList,'n') }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="请求人：">{{ detail.requester }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="事件分类：">{{ detail.category | tableVal(eventList,'t')}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="联系方式：">{{ detail.contact }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="请求标题：">{{ detail.title }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="紧急度：">{{ detail.emergency | tableVal(emergency) }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="请求途径：">{{ detail.origin | tableVal(eventOrigin) }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="满意度：">
                            <el-rate disabled v-model="detail.satisfaction"></el-rate>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="优先级：">{{ detail.priority | tableVal(priority)}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="难易程度：">{{ detail.complexity | tableVal(complexity)}}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="影响范围：">{{ detail.influence | tableVal(influence) }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="风险等级：">{{ detail.risk | tableVal(risk) }}</el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="标签：">
                            <span v-for="item in detail.label">{{ item }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="主请求：">{{ detail.mainEvent }}</el-form-item>
                    </el-col>

                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="项目名称：">{{detail.projectName | tableVal(projectName)}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="服务请求：">{{detail.serviceClass | tableVal(serviceClass)}}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="上传附件：">
                            <ul>
                                <li v-for="item in detail.attachment" >
                                    <a :href="item.url" style="color: #1890EF">{{ item.name }}</a>
                                    <span>上传时间:&emsp;{{item.uploadTime?item.uploadTime:'无'}}</span>
                                    <span class="preview" @click="previewEvent(item)">预览</span>
                                </li>
                            </ul>

                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="环境：">
                            {{detail.env | tableVal(env)}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="完成时间：">
                            {{detail.endTime}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否高危操作：">
                            {{detail.isHighRiskOperation ?'是':'否'}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="详细描述：">
                            <span v-html="detail.description"></span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>
    </div>
</template>

<script>
    export default {
        props:{
            detail:Object,
            companyList:Array,
            eventList:Array
        },
        data() {
            return {

            }
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            // 请求路径
            eventOrigin(){
                return this.dictionary.event_origin;
            },
            // 紧急度
            emergency(){
                return this.dictionary.emergency;
            },
            // 优先级
            priority(){
                return this.dictionary.priority;
            },
            // 难易程度
            complexity(){
                return this.dictionary.complexity;
            },
            // 影响范围
            influence(){
                return this.dictionary.influence;
            },
            //风险等级
            risk(){
                return this.dictionary.event_risk
            },
            //环境
            env(){
                return this.dictionary.env
            },
            //项目名称
            projectName(){
                return this.dictionary.project_name
            },
            //服务请求
            serviceClass(){
                return this.dictionary.service_class
            },
        },
        created() {

        },
        methods: {
            previewEvent(row){
                this.$router.push({
                    name:'Preview',
                    path:'/preview',
                    query: {
                        file:row
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .zebra-item{
        span{
            padding-right: 10px;
        }
    }
    .zebra-crossing-detail .zebra-item .el-form-item__content a{
        float: left;
        margin-left: 20px;
    }
    .preview{
        color:blue;
        cursor: pointer;
    }
</style>
